// import React, { useEffect, useState } from "react";
// import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
// import { useForm, useFieldArray } from "react-hook-form";
// import {
//   errorToastify,
//   successToastify,
// } from "../../../Components/Common/Toaster";
// import { getSessionData } from "../../../helpers/sessionDetailsParser";
// import { moveProductTypeFunc } from "../../../helpers/urlConfig/apiFunctions";
// import { generateUniqueId } from "../../../helpers/documentTitle";
// import errorResponseHandler from "../../../helpers/errorResponseHandler";
// import { ToastContainer } from "react-toastify";

// function NewHUIDCreate({
//   move_modal_list,
//   set_move_modal_list,
//   move_tog_list,
//   fetchData,
//   moveProductType,
// }) {
//   const { register, handleSubmit, reset, control } = useForm({
//     defaultValues: {
//       ...moveProductType,
//       pairs: moveProductType?.pairs || [{ gram: "", huid: "" }],
//     },
//   });

//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "pairs",
//   });

//   const [isPairingEnabled, setIsPairingEnabled] = useState(false);

//   useEffect(() => {
//     if (moveProductType) {
//       reset({
//         ...moveProductType,
//         pairs: moveProductType?.pairs || [{ gram: "", huid: "" }],
//       });
//     }
//   }, [moveProductType, reset]);

//   const onSubmit = async (data) => {
//     try {
//       data.created_by = getSessionData("user_id");
//       data.unique_stock_id = generateUniqueId();

//       let dataToDB;
//       if (!isPairingEnabled) {
//         dataToDB = {
//           unique_stock_id: generateUniqueId(),
//           product_type_name: data.product_type_name,
//           gram: data.gram,
//           stock: data.stock,
//           huid: data.huid,
//           gender: data.gender,
//           age: data.age,
//           model_name: data.model_name,
//           product_name: data.product_name,
//           created_by: getSessionData("user_id"),
//           pairs: null,
//         };
//       } else {
//         dataToDB = data;
//       }

//       const response = await moveProductTypeFunc(dataToDB);
//       console.log("response", response);
//       if (response.statusCode === 200) {
//         successToastify("Product Type updated successfully!");
//         fetchData();
//         set_move_modal_list(false);
//       } else {
//         if (response.data.includes("Duplicate")) {
//           console.log("move huid response", response);
//           errorToastify("HUID or Product Type or Model already exists!");
//         } else {
//           errorResponseHandler(response);
//         }
//       }
//     } catch (error) {
//       console.error("Error:", error.message);
//     }
//   };

//   return (
//     <Modal isOpen={move_modal_list} toggle={() => move_tog_list()} centered>
//       <ModalHeader className="bg-light p-3" toggle={() => move_tog_list()}>
//         Move Product Type
//       </ModalHeader>
//       <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
//         <ModalBody>
//           <div className="mb-3">
//             <label htmlFor="product-name" className="form-label">
//               Product Name
//             </label>
//             <input
//               type="text"
//               id="product-name"
//               className="form-control"
//               placeholder="Enter Product Name"
//               disabled
//               {...register("product_name", {
//                 required: "Product Name is required",
//               })}
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="product-type-name" className="form-label">
//               Product Type Name
//             </label>
//             <input
//               type="text"
//               id="product-type-name"
//               className="form-control"
//               placeholder="Enter Product Type Name"
//               disabled
//               {...register("product_type_name", {
//                 required: "Product Type Name is required",
//               })}
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="model-name" className="form-label">
//               Model Name
//             </label>
//             <input
//               type="text"
//               id="model-name"
//               disabled
//               className="form-control"
//               placeholder="Enter Model Name"
//               {...register("model_name", {
//                 required: "Model Name is required",
//               })}
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="model-name" className="form-label">
//               Quantity
//             </label>
//             <input
//               type="text"
//               id="model-name"
//               disabled
//               className="form-control"
//               placeholder="Enter Stock"
//               {...register("stock")}
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="gram" className="form-label">
//               Gram <span style={{ color: "red" }}>*</span>
//             </label>
//             <input
//               type="text"
//               id="gram"
//               className="form-control"
//               placeholder="Enter Gram"
//               {...register("gram", {
//                 required: "Gram is required",
//               })}
//             />
//           </div>

//           {!isPairingEnabled && (
//             // <div className="mb-3">
//             //   <label htmlFor="huid" className="form-label">
//             //     HUID
//             //   </label>
//             //   <input
//             //     type="text"
//             //     id="huid"
//             //     className="form-control"
//             //     placeholder="Enter HUID"
//             //     {...register("huid", {
//             //       required: "HUID is required",
//             //     })}
//             //   />
//             // </div>
//             <div className="mb-3">
//               <label htmlFor="huid" className="form-label">
//                 HUID
//               </label>
//               <input
//                 type="text"
//                 id="huid"
//                 className="form-control"
//                 placeholder="Enter HUID"
//                 {...register("huid", {
//                   required: "HUID is required",
//                   pattern: {
//                     value: /^[a-zA-Z0-9]+$/, // Alphanumeric regex
//                     message: "HUID must be alphanumeric",
//                   },
//                 })}
//               />
//             </div>
//           )}

//           <div className="form-check mb-3">
//             <input
//               type="checkbox"
//               id="enable-pairing"
//               className="form-check-input"
//               checked={isPairingEnabled}
//               onChange={() => setIsPairingEnabled(!isPairingEnabled)}
//             />
//             <label htmlFor="enable-pairing" className="form-check-label">
//               Add Sets
//             </label>
//           </div>

//           {isPairingEnabled && (
//             <div className="mb-3">
//               <label className="form-label">HUID-Gram Sets</label>
//               {fields.map((field, index) => (
//                 <div key={field.id} className="d-flex align-items-center mb-2">
//                   <input
//                     type="text"
//                     className="form-control me-2"
//                     placeholder="Enter HUID"
//                     {...register(`pairs.${index}.huid`, {
//                       required: "HUID is required",
//                     })}
//                   />
//                   <input
//                     type="text"
//                     className="form-control me-2"
//                     placeholder="Enter Gram"
//                     {...register(`pairs.${index}.gram`, {
//                       required: "Grams is required",
//                     })}
//                   />
//                   <button
//                     type="button"
//                     className="btn btn-danger"
//                     onClick={() => remove(index)}
//                     disabled={fields.length === 1}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 className="btn btn-primary mt-2"
//                 onClick={() => append({ gram: "", huid: "" })}
//               >
//                 Add Sets
//               </button>
//             </div>
//           )}
//         </ModalBody>
//         <ModalFooter>
//           <div className="hstack gap-2 justify-content-end">
//             <button
//               type="button"
//               className="btn btn-light"
//               onClick={() => set_move_modal_list(false)}
//             >
//               Close
//             </button>
//             <button type="submit" className="btn btn-success">
//               Move Product Type
//             </button>
//           </div>
//         </ModalFooter>
//       </form>
//       <ToastContainer />
//     </Modal>
//   );
// }

// export default NewHUIDCreate;

import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm, useFieldArray } from "react-hook-form";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import { moveProductTypeFunc } from "../../../helpers/urlConfig/apiFunctions";
import { generateUniqueId } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";
import { ToastContainer } from "react-toastify";

function NewHUIDCreate({
  move_modal_list,
  set_move_modal_list,
  move_tog_list,
  fetchData,
  moveProductType,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      ...moveProductType,
      pairs: moveProductType?.pairs || [{ gram: "", huid: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "pairs",
  });

  const [isPairingEnabled, setIsPairingEnabled] = useState(false);

  // Watch form values
  const watchedStock = watch("stock");
  const watchedGram = watch("gram");
  const watchedPairs = watch("pairs");

  useEffect(() => {
    if (moveProductType) {
      reset({
        ...moveProductType,
        pairs: moveProductType?.pairs || [{ gram: "", huid: "" }],
      });
    }
  }, [moveProductType, reset]);

  const validateQuantities = (data) => {
    const stock = parseFloat(data.stock) || 0;

    if (!isPairingEnabled) {
      const gram = parseFloat(data.gram) || 0;
      if (gram <= 0) {
        errorToastify("Gram must be greater than 0");
        return false;
      }
      if (stock <= 0) {
        errorToastify("Stock must be greater than 0");
        return false;
      }
      if (gram > stock) {
        errorToastify("Gram cannot exceed available stock");
        return false;
      }
    } else {
      const totalPairsGram = data.pairs.reduce((sum, pair) => {
        return sum + (parseFloat(pair.gram) || 0);
      }, 0);

      if (totalPairsGram <= 0) {
        errorToastify("Total grams in sets must be greater than 0");
        return false;
      }
      if (stock <= 0) {
        errorToastify("Stock must be greater than 0");
        return false;
      }
      // if (totalPairsGram > stock) {
      //   errorToastify("Total grams in sets cannot exceed available stock");
      //   return false;
      // }
    }
    return true;
  };

  const onSubmit = async (data) => {
    // if (!validateQuantities(data)) {
    //   return;
    // }

    try {
      data.created_by = getSessionData("user_id");
      data.unique_stock_id = generateUniqueId();

      let dataToDB;
      if (!isPairingEnabled) {
        dataToDB = {
          unique_stock_id: generateUniqueId(),
          product_type_name: data.product_type_name,
          gram: data.gram,
          stock: data.stock,
          huid: data.huid,
          gender: data.gender,
          age: data.age,
          model_name: data.model_name,
          product_name: data.product_name,
          created_by: getSessionData("user_id"),
          pairs: null,
        };
      } else {
        dataToDB = data;
      }

      const response = await moveProductTypeFunc(dataToDB);
      if (response.statusCode === 200) {
        successToastify("Product Type updated successfully!");
        fetchData();
        set_move_modal_list(false);
      } else {
        console.log("move huid response", response.data);
        if (response.data.includes("Duplicate")) {
          errorToastify("HUID or Product Type or Model already exists!");
        } else {
          errorResponseHandler(response);
        }
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <Modal isOpen={move_modal_list} toggle={() => move_tog_list()} centered>
      <ModalHeader className="bg-light p-3" toggle={() => move_tog_list()}>
        Move Product Type
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          {/* Previous input fields remain same until stock */}
          <div className="mb-3">
            <label htmlFor="product-name" className="form-label">
              Product Name
            </label>
            <input
              type="text"
              id="product-name"
              className="form-control"
              placeholder="Enter Product Name"
              disabled
              {...register("product_name", {
                required: "Product Name is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="product-type-name" className="form-label">
              Product Type Name
            </label>
            <input
              type="text"
              id="product-type-name"
              className="form-control"
              placeholder="Enter Product Type Name"
              disabled
              {...register("product_type_name", {
                required: "Product Type Name is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="model-name" className="form-label">
              Model Name
            </label>
            <input
              type="text"
              id="model-name"
              disabled
              className="form-control"
              placeholder="Enter Model Name"
              {...register("model_name", {
                required: "Model Name is required",
              })}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="stock" className="form-label">
              Quantity
            </label>
            <input
              type="number"
              id="stock"
              disabled
              className="form-control"
              placeholder="Enter Stock"
              {...register("stock", {
                required: "Stock is required",
                min: { value: 0, message: "Stock cannot be negative" },
              })}
            />
            {errors.stock && (
              <span className="text-danger">{errors.stock.message}</span>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="gram" className="form-label">
              Gram <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              id="gram"
              className="form-control"
              placeholder="Enter Gram"
              {...register("gram", {
                required: "Gram is required",
                min: { value: 0.1, message: "Gram must be greater than 0" },
              })}
            />
            {errors.gram && (
              <span className="text-danger">{errors.gram.message}</span>
            )}
          </div>

          {!isPairingEnabled && (
            <div className="mb-3">
              <label htmlFor="huid" className="form-label">
                HUID
              </label>
              <input
                type="text"
                id="huid"
                className="form-control"
                placeholder="Enter HUID"
                {...register("huid", {
                  required: "HUID is required",
                  pattern: {
                    value: /^[a-zA-Z0-9]+$/,
                    message: "HUID must be alphanumeric",
                  },
                })}
              />
              {errors.huid && (
                <span className="text-danger">{errors.huid.message}</span>
              )}
            </div>
          )}

          <div className="form-check mb-3">
            <input
              type="checkbox"
              id="enable-pairing"
              className="form-check-input"
              checked={isPairingEnabled}
              onChange={() => setIsPairingEnabled(!isPairingEnabled)}
            />
            <label htmlFor="enable-pairing" className="form-check-label">
              Add Sets
            </label>
          </div>

          {isPairingEnabled && (
            <div className="mb-3">
              <label className="form-label">HUID-Gram Sets</label>
              {fields.map((field, index) => (
                <div key={field.id} className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Enter HUID"
                    {...register(`pairs.${index}.huid`, {
                      required: "HUID is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+$/,
                        message: "HUID must be alphanumeric",
                      },
                    })}
                  />
                  <input
                    type="number"
                    className="form-control me-2"
                    placeholder="Enter Gram"
                    {...register(`pairs.${index}.gram`, {
                      required: "Grams is required",
                      min: {
                        value: 0.1,
                        message: "Gram must be greater than 0",
                      },
                    })}
                  />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => remove(index)}
                    disabled={fields.length === 1}
                  >
                    Remove
                  </button>
                  {errors.pairs?.[index]?.huid && (
                    <span className="text-danger">
                      {errors.pairs[index].huid.message}
                    </span>
                  )}
                  {errors.pairs?.[index]?.gram && (
                    <span className="text-danger">
                      {errors.pairs[index].gram.message}
                    </span>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="btn btn-primary mt-2"
                onClick={() => append({ gram: "", huid: "" })}
              >
                Add Sets
              </button>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => set_move_modal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success">
              Move Product Type
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastContainer />
    </Modal>
  );
}

export default NewHUIDCreate;
